import React from 'react';
import { css } from '@emotion/css';
import ApplicationContainer from '../../../state/containers/ApplicationContainer';
import AppliedApplicationTemplateContainer from '../../../state/containers/AppliedApplicationTemplateContainer';
import AppliedAppSectionSelector from './AppliedAppSectionSelector';
import CustomScrollbars from '../../../components/structure/CustomScrollbars';
import { color_shades_dark } from '../../../constants/colors';
import TemplateSectionStatusModel from '../../../models/templating/TemplateSectionStatusModel';
import TemplateFormSectionModel from '../../../models/templating/api/TemplateFormSectionModel';
import SparkTemplateFormSectionModel from '../../../models/templating/api/SparkTemplateFormSectionModel';

interface AppliedAppTemplateSectionMenuProps {
    history: any
    applicationId: string
    appContainer: ApplicationContainer
    appliedAppTemplateContainer: AppliedApplicationTemplateContainer
    isFinishSelected: boolean
    isStartSelected?: boolean
    sections: TemplateFormSectionModel[] | SparkTemplateFormSectionModel[] | any[]
    activeSection?: TemplateSectionStatusModel
    isNew?: boolean
    onFinishSelect: () => void
    onStartSelect: () => void
    onSectionSelect: (section: TemplateFormSectionModel, appliedTemplateId: string) => void
    firstSectionName?: string
    hideStart?: boolean
}

class AppliedAppTemplateSectionMenu extends React.Component<AppliedAppTemplateSectionMenuProps> {
    handleActiveSectionChange(status: TemplateSectionStatusModel) {
        const section = this.props.sections.find((section) => {
            return section.section.id === status.section.id
        });
        this.props.onSectionSelect(status.section, section.appliedTemplateId);
    }
    handleFinishSelected() {
        this.props.onFinishSelect();
    }
    handleStartSelected() {
        if(this.props.hideStart) return;
        this.props.onStartSelect();
    }
    render() {
        return (
            <div className={containerStyle}>
                <CustomScrollbars className={scrollContainer}>
                    <AppliedAppSectionSelector
                        firstSectionName={this.props.firstSectionName}
                        sections={this.props.sections}
                        activeSection={this.props.activeSection}
                        isStartSelected={this.props.isStartSelected && !this.props.activeSection}
                        isFinishSelected={this.props.isFinishSelected && !this.props.activeSection}
                        isNew={this.props.isNew}
                        onChange={this.handleActiveSectionChange.bind(this)}
                        onStartSelect={this.handleStartSelected.bind(this)} 
                        onFinishSelect={this.handleFinishSelected.bind(this)}
                        hideStart={this.props.hideStart}
                    />
                </CustomScrollbars>
            </div>
        )
    }
}

const containerStyle = css`
    flex: 1;
`
const scrollContainer = css`
    flex: 1;
    background: white;
    border-right: 1px solid ${color_shades_dark};
`

export default AppliedAppTemplateSectionMenu;